// 9fbef606107a605d69c0edbcd8029e5d 
export default {
  IMG_DATA: {
    phoneIcon: ['t_dwnld_app_promo_phone_m'],
    genericIcon: ['t_dwnld_app_promo_generic_icon_m'],
    storeBtn: ['t_dwnld_app_promo_store_btn_m'],
  },
};
